import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  PLATFORM_ID,
  inject,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LoginService } from '../../services/login.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StorageService } from '../../services/storage.service';
import { ConfigService } from '../../services/config.service';

export interface LoginBody {
  mail: string;
  password: string;
  otp: string;
}
@Component({
  selector: 'app-login',
  imports: [FormsModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent implements OnInit {
  loginService = inject(LoginService);
  private configService = inject(ConfigService);
  private activatedRoute = inject(ActivatedRoute);

  token: string | null = '';
  apiUrl: string = 'demo';
  private router = inject(Router);
  isDemoMode = false;
  platformId = inject(PLATFORM_ID);
  private cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((res: Params) => {
      this.token = res['token'];
      if (this.token != null) this.loginService.createRefreshToken(this.token);
    });
  }

  loginObj: LoginBody = {
    mail: '',
    password: '',
    otp: '',
  };
  loginToken: string = '';
  step = 1;
  message = '';
  constructor(
    private snackBar: MatSnackBar,
    private storageService: StorageService,
  ) {}
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
    });
  }

  verifyOtp() {
    //console.log(this.loginObj)
    this.loginService.verifyLogin(this.loginObj.mail, this.loginObj.otp).subscribe({
      next: (res) => {
        this.message = '✅ Login erfolgreich mit 2FA';
        if (res.token) {
          this.loginToken = res.token;
          this.loginService.setTokens(res.token, res.refreshToken);
          this.configService.loadConfig();
          this.storageService.setCookie('apiUrl', res.url);
          this.router.navigateByUrl('/home');
        }
      },
      error: () => {
        this.message = '❌ Falscher Code';
      },
    });
  }
  onLogin() {
    if (this.loginObj.mail && this.loginObj.password) {
      this.loginService.getLogin(this.loginObj).subscribe({
        next: (res) => {
          if (res.require2FA) {
            this.step = 2;
            this.cdr.markForCheck();
            return;
          }
          if (res.token && res.refreshToken) {
            this.loginToken = res.token;
            this.loginService.setTokens(res.token, res.refreshToken);
            this.loginService.setCustomerApiUrl(res.url);
            this.configService.loadConfig();
            
            this.router.navigateByUrl('/home');
          } else {
            this.openSnackBar('Login fehlgeschlagen', 'OK');
          }
        },
        error: (err) => {
          this.openSnackBar('Login fehlgeschlagen', 'OK');
        },
      });
    } else {
      this.openSnackBar('Unvollständiger Login', 'OK');
    }
  }
}
